module.exports = __webpack_public_path__ + "img/pt_pt.21e9bd55.png";